import { cva } from 'class-variance-authority'
import Image from 'next/image'

import { cn } from '../../../lib/utils'

import Alert from './assets/alert.svg'
import Error from './assets/error.svg'
import Info from './assets/info.svg'
import Success from './assets/success.svg'

const variants = cva('flex w-full gap-2 rounded-md p-4', {
  variants: {
    variant: {
      primary: 'bg-surface-brand-secondary-subtle',
      success: 'bg-surface-brand-primary-subtle',
      alert: 'bg-surface-brand-tertiary-subtle',
      error: 'bg-surface-warning-error-subtle',
    },
  },
})

const linkVariants = cva('text-base underline', {
  variants: {
    variant: {
      primary: 'text-text-brand-secondary',
      success: 'text-text-brand-primary',
      alert: 'text-text-brand-tertiary',
      error: 'text-text-error',
    },
  },
})

interface Props {
  variant: 'primary' | 'success' | 'alert' | 'error'
  title?: string
  description: string
  linkText?: string
  linkUrl?: string
  onLinkClick?: () => void
}

const images = {
  success: Success,
  alert: Alert,
  error: Error,
  primary: Info,
}

export function HighlightText({ variant, title, description, linkText, linkUrl, onLinkClick }: Props) {
  return (
    <div className={cn(variants({ variant }))}>
      <div className="flex h-6 shrink-0 items-center">
        <Image src={images[variant]} width={16} height={16} alt="Icon" />
      </div>
      <div className="flex h-full flex-col justify-center gap-0.5">
        {title && <p className="text-base font-medium">{title}</p>}
        <p className="text-sm text-text-secondary">{description}</p>
        {linkUrl && (
          <a href={linkUrl} className={cn(linkVariants({ variant }))} onClick={onLinkClick}>
            {linkText}
          </a>
        )}
      </div>
    </div>
  )
}
